import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { initFacebookPixel } from './lib/fbPixel';
export function App() {
  useEffect(() => {
    // Diferimos la carga del pixel (script externo) para no frenar el primer render.
    const w = window as any;
    const schedule = w.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 1500));
    const id = schedule(() => initFacebookPixel());
    return () => {
      if (w.cancelIdleCallback && typeof id === 'number') {
        w.cancelIdleCallback(id);
      }
    };
  }, []);
  return <LandingPage data-id="element-0" data-mp="2mjzo18kbdvo5" />;
}